import { EnumAttachmentType } from '../enums/attachment-type.enum';

const EXTENSION_MAP: Record<string, EnumAttachmentType> = {
  pdf: EnumAttachmentType.PDF,
  xlsx: EnumAttachmentType.EXCEL,
  xls: EnumAttachmentType.EXCEL,
  csv: EnumAttachmentType.EXCEL,
  pptx: EnumAttachmentType.POWERPOINT,
  ppt: EnumAttachmentType.POWERPOINT,
  docx: EnumAttachmentType.WORD,
  doc: EnumAttachmentType.WORD,
  png: EnumAttachmentType.IMAGE,
  jpg: EnumAttachmentType.IMAGE,
  jpeg: EnumAttachmentType.IMAGE,
  gif: EnumAttachmentType.IMAGE,
  webp: EnumAttachmentType.IMAGE,
  bmp: EnumAttachmentType.IMAGE,
  tif: EnumAttachmentType.IMAGE,
  tiff: EnumAttachmentType.IMAGE,
  txt: EnumAttachmentType.TEXT,
  md: EnumAttachmentType.TEXT,
  markdown: EnumAttachmentType.TEXT
};

const MIME_MAP: Record<string, EnumAttachmentType> = {
  'application/pdf': EnumAttachmentType.PDF,
  'text/plain': EnumAttachmentType.TEXT,
  'text/markdown': EnumAttachmentType.TEXT,
  'text/csv': EnumAttachmentType.EXCEL
};

const MIME_PREFIX_MAP: Array<[string, EnumAttachmentType]> = [
  ['image/', EnumAttachmentType.IMAGE],
  ['application/vnd.openxmlformats-officedocument.spreadsheetml', EnumAttachmentType.EXCEL],
  ['application/vnd.openxmlformats-officedocument.presentationml', EnumAttachmentType.POWERPOINT],
  ['application/vnd.openxmlformats-officedocument.wordprocessingml', EnumAttachmentType.WORD]
];

const fromMime = (mime: string): EnumAttachmentType | null => {
  const normalized = mime.toLowerCase().split(';')[0].trim();
  if (MIME_MAP[normalized]) {
    return MIME_MAP[normalized];
  }
  const prefix = MIME_PREFIX_MAP.find(([start]) => normalized.startsWith(start));
  return prefix ? prefix[1] : null;
};

export function getAttachmentType(
  name: string | null | undefined,
  mime?: string | null
): EnumAttachmentType {
  const byMime = mime ? fromMime(mime) : null;
  if (byMime) {
    return byMime;
  }
  const ext = name?.split('.').pop()?.toLowerCase();
  return (ext && EXTENSION_MAP[ext]) || EnumAttachmentType.GENERIC;
}

const TYPE_LABELS: Record<EnumAttachmentType, string> = {
  [EnumAttachmentType.PDF]: 'PDF',
  [EnumAttachmentType.EXCEL]: 'Planilha',
  [EnumAttachmentType.POWERPOINT]: 'Apresentação',
  [EnumAttachmentType.WORD]: 'Documento',
  [EnumAttachmentType.IMAGE]: 'Imagem',
  [EnumAttachmentType.TEXT]: 'Texto',
  [EnumAttachmentType.GENERIC]: 'Arquivo'
};

export function attachmentTypeLabel(
  mime?: string | null,
  name?: string | null
): string {
  return TYPE_LABELS[getAttachmentType(name, mime)];
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  const kb = bytes / 1024;
  if (kb < 1024) {
    return `${Math.round(kb)} KB`;
  }
  return `${(kb / 1024).toFixed(1).replace('.', ',')} MB`;
}
